import { DosageTemplate, DosageTemplateUpdateCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { mapFormBeanToExtendedDosage } from '../../prescriptions/prescription/extendedDosage/extendedDosage.utils';
import {
   ExtendedDosageFormBean,
   ExtendedDosageFormController,
} from '../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm.types';

type DosageTemplatesUpdateTemplateButtonProps = {
   readonly handleSubmit: ExtendedDosageFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
};

const commandCreator = (parameters: ExtendedDosageFormBean, templateId: number): DosageTemplateUpdateCommand => {
   const command = new DosageTemplateUpdateCommand();
   command.id = templateId;
   command.name = parameters.templateName!;
   command.extendedDosage = mapFormBeanToExtendedDosage(parameters);
   return command;
};

export const DosageTemplatesUpdateTemplateButton = (props: DosageTemplatesUpdateTemplateButtonProps): JSX.Element => {
   return (
      <FormsTemplates.SendTemplateButton<ExtendedDosageFormBean, DosageTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={(parameters, id) => commandCreator(parameters, id as number)}
         onSuccess={props.onSuccess}
      />
   );
};
